import { StandardDivProps } from '@sprinx/react-mui-components';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import React from 'react';
import AppHeader from '../MainLayout/components/AppHeader';
import MainNavigation from '../MainLayout/components/MainNavigation';
import AppFooter from './components/AppFooter';

export type InfoLayoutClassKey = 'root' | 'content';

export interface InfoLayoutProps extends StandardDivProps<InfoLayoutClassKey> {
  children?: React.ReactNode;
}

const useStyles = makeStyles(
  (theme) =>
    createStyles<InfoLayoutClassKey, {}>({
      root: {
        marginTop: 'auto',
        minHeight: '100vh',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      content: {
        marginTop: theme.spacing(8),
        [theme.breakpoints.up('md')]: {
          marginTop: theme.spacing(10),
        },
        padding: theme.spacing(4, 0),
        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(8, 6),
        },
        display: 'flex',
        flexGrow: 1,
        height: '100%',
      },
    }),
  { name: 'InfoLayout' },
);

const InfoLayout: React.FC<InfoLayoutProps> = ({ children = null, classes: pClasses, className, ...rest }) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  useTheme();
  const handleDrawerToggle = React.useCallback((v) => {
    setOpen(typeof v === 'boolean' ? v : (prev) => !prev);
  }, []);

  return (
    <div className={classes.root} {...rest}>
      <AppHeader handleDrawerToggle={handleDrawerToggle} />

      {/* only temporary nav in modal (for mobile) */}
      <MainNavigation onClose={() => handleDrawerToggle(false)} open={open} />
      <div className={classes.content}>{children}</div>
      <AppFooter />
    </div>
  );
};

export default InfoLayout;
